import { BaseSyntheticEvent } from 'react';

import { useUserKeyLookupQueryContext } from '../contexts/UserKeyLookupQueryContext';
import { FormState } from '../types';
import { getLookupRequestFromFormState } from '../utils/getLookupRequestFromFormState';
import { useErrorToastOnUnsuccessfulLookup } from './useErrorToastOnUnsuccessfulLookup';
import { useRedirectOnSuccessfulLookup } from './useRedirectOnSuccessfulLookup';

export const useSubmitLookupForm = (formState: FormState) => {
  // "Submit" callback for lookup form
  const { lookup, isLoading } = useUserKeyLookupQueryContext();
  const submit = (event?: Pick<BaseSyntheticEvent, 'preventDefault'>) => {
    event?.preventDefault();
    lookup(getLookupRequestFromFormState(formState));
  };

  // Submission handler side-effects (redirect on success, show error on failure)
  const { isRedirecting } = useRedirectOnSuccessfulLookup();
  useErrorToastOnUnsuccessfulLookup();

  // Derived state
  const isSubmitting = isLoading || isRedirecting;
  const canSubmit = !isSubmitting && !!formState.identifier.length;

  return {
    submit,
    isSubmitting,
    canSubmit,
  };
};
